import { useEffect, useState } from "react";
import PendingDashboard from "../../components/candidate-dashboard/pending-dashboard";
import ApprovedDashboard from "../../components/candidate-dashboard/approved-dashboard";
import RejectedDashboard from "../../components/candidate-dashboard/rejected-dashboard";
import DashboardHome from "./dashboard-home";
import tokenService from "../../services/token-service";
import { fetchUserApplications } from "../../utils/application-service";

const EmployeeDashboard = () => {
  const [employee, setEmployee] = useState(null);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  const userDetails = tokenService.getUserDetails();
  const token = tokenService.getToken();

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const response = await fetchUserApplications(userDetails?._id, token);
        if (response?.user) {
          setEmployee({
            ...response.user,
            promoCode: response.promoCode?.code || null
          });
          setApplications(response.applications || []);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    if (token && userDetails?._id) {
      loadData();
    }
  }, [token, userDetails?._id]);

  const renderDashboard = () => {
    if (!employee) {
      return (
        <div className="flex items-center justify-center h-96">
          <p className="text-gray-500 dark:text-gray-400">
            No user data found. Please log in.
          </p>
        </div>
      );
    }

    const activeApp = applications.find(app => !app.isArchived) || applications[0];
    const appStatus = activeApp?.status?.toLowerCase() || "none";

    const onboardingStatuses = [
      "none",
      "applied",
      "initial test submitted",
      "initial test passed",
      "initial test failed",
      "training completed",
      "final test submitted",
      "final test passed",
      "final test failed"
    ];

    if (onboardingStatuses.includes(appStatus)) {
      return <DashboardHome />;
    }

    const dashboardStatusValue =
      employee.dashboardStatus?.value?.toLowerCase() || "pending";

    const rejectedDocuments = [];
    const anyDocumentRejected = applications.some((app) => {
      const docStatus = app.documentStatus || {};
      Object.entries(docStatus).forEach(([docType, status]) => {
        if (status?.toLowerCase() === "rejected") {
          rejectedDocuments.push(docType);
        }
      });
      return Object.values(docStatus).some(
        (status) => status?.toLowerCase() === "rejected"
      );
    });
    switch (dashboardStatusValue) {
      case "approved":
        return <ApprovedDashboard employee={employee} />;
      case "rejected":
        return <RejectedDashboard employee={employee} />;
      default:
        return (
          <PendingDashboard
            employee={employee}
            hasRejectedDocument={anyDocumentRejected}
            rejectedDocuments={rejectedDocuments} 
          />
        );
    }
  };
  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <p className="text-gray-500 dark:text-gray-400">Loading dashboard...</p>
      </div>
    );
  }

  return <div className="w-full">{renderDashboard()}</div>;
};

export default EmployeeDashboard;
